import { connect } from 'react-redux';
import { logout } from 'dux/user';
import { setSessionExtend } from 'dux/session';
import { validateSession } from 'dux/user';
// component
import SessionModal from './session-modal';

const mapStateToProps = ( state ) => ( {
    session: state.session
} );

const mapDispatchToProps = {
    logout,
    setSessionExtend,
    extendSession: validateSession
};

export default connect( mapStateToProps, mapDispatchToProps )( SessionModal );
